/// <reference types="grecaptcha" />
import '@ts/pages/page-defaults';
import { ___, getLocale } from '@ts/common/language';
import { fetchData, isHttpErrorWithStatus, isHttpErrorWithValidationData } from '@ts/common/request';
const form = document.getElementById('simulator-early-access-form');
if (form) {
    const sitekey = form.getAttribute('data-recaptcha-sitekey') ?? '';
    const successEl = document.getElementById('inquiry-success');
    const formWrapper = document.getElementById('inquiry-form-wrapper');
    const alertEl = document.getElementById('form-alert');
    const submitBtn = form.querySelector('#submit-btn');
    function showFieldError(field, message) {
        const el = document.getElementById('error-' + field);
        if (el) {
            el.textContent = message;
            el.classList.remove('hidden');
        }
        const input = form.querySelector(`[name="data[${field}]"]`);
        if (input)
            input.classList.add('invalid');
    }
    function clearErrors() {
        form.querySelectorAll('.invalid-message').forEach(el => {
            el.textContent = '';
            el.classList.add('hidden');
        });
        form.querySelectorAll('.invalid').forEach(el => el.classList.remove('invalid'));
        if (alertEl) {
            alertEl.textContent = '';
            alertEl.classList.add('hidden');
        }
    }
    function showAlert(message) {
        if (alertEl) {
            alertEl.textContent = message;
            alertEl.classList.remove('hidden');
        }
    }
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        clearErrors();
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.classList.add('processing');
        }
        grecaptcha.ready(() => {
            grecaptcha.execute(sitekey, { action: 'simulator_early_access' }).then(async (token) => {
                const body = {
                    captcharesponse: token,
                    data: {
                        sport: (form.querySelector('#sport'))?.value,
                        level: (form.querySelector('#level'))?.value,
                        reason: (form.querySelector('#reason'))?.value,
                    },
                };
                try {
                    await fetchData('/api/v1/inquiry/simulator_early_access?locale=' + getLocale(), {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': window.csrf,
                        },
                        body: JSON.stringify(body),
                    });
                    // Success
                    if (formWrapper)
                        formWrapper.classList.add('hidden');
                    if (successEl) {
                        successEl.classList.remove('hidden');
                        // successEl.scrollIntoView({behavior: 'smooth'});
                        document.querySelectorAll('a[href="#early-access"]').forEach(el => {
                            el.style.display = 'none';
                        });
                    }
                }
                catch (error) {
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.classList.remove('processing');
                    }
                    if (isHttpErrorWithValidationData(error)) {
                        for (const [key, messages] of Object.entries(error.data.errors)) {
                            const field = key.replace('data.', '');
                            showFieldError(field, messages[0]);
                        }
                        showAlert(___({ en: 'Please check your inputs.', de: 'Bitte überprüfe deine Eingaben.' }));
                    }
                    else if (isHttpErrorWithStatus(error, 429)) {
                        showAlert(___({ en: 'You have already submitted a request recently. Please try again later.', de: 'Du hast bereits kürzlich eine Anfrage gesendet. Bitte versuche es später erneut.' }));
                    }
                    else if (isHttpErrorWithStatus(error, 401)) {
                        window.location.href = '/' + getLocale() + '/login';
                    }
                    else {
                        showAlert(___({ en: 'An error occurred. Please try again.', de: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.' }));
                    }
                    //   form.scrollIntoView({behavior: 'smooth'});
                }
            });
        });
    });
}
